module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-8.69f0103e.png";